import { render, staticRenderFns } from "./editAgentProduct.vue?vue&type=template&id=6942388b&scoped=true"
import script from "./editAgentProduct.vue?vue&type=script&lang=ts"
export * from "./editAgentProduct.vue?vue&type=script&lang=ts"
import style0 from "./editAgentProduct.vue?vue&type=style&index=0&id=6942388b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942388b",
  null
  
)

export default component.exports